"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getGMT = exports.circular = exports.getAngle = exports.circularDistance = exports.intersection = void 0;
var tz_lookup_1 = __importDefault(require("tz-lookup"));
var dayjs_1 = __importDefault(require("./dayjs"));
function intersection(arr1, arr2) {
    return arr1.filter(function (i) { return arr2.includes(i); });
}
exports.intersection = intersection;
function circularDistance(a1, a2, length) {
    var d = Math.abs(a1 - a2) % length;
    return Math.min(d, length - d);
}
exports.circularDistance = circularDistance;
function getAngle(lon1, lon2) {
    return circularDistance(Math.floor(lon1), Math.floor(lon2), 360);
}
exports.getAngle = getAngle;
function circular(value, length) {
    value %= length;
    return value < 0 ? value + length : value;
}
exports.circular = circular;
function getGMT(dt, lat, lon) {
    var DIV = 15;
    var date = dayjs_1["default"].utc(dt);
    var tzString = (0, tz_lookup_1["default"])(lat, lon);
    var tzToks = tzString.split('/');
    if (date.isSameOrAfter(dayjs_1["default"].utc('01.03.2024', 'DD.MM.YYYY')) &&
        tzToks[0] === 'Asia' &&
        ['Almaty', 'Qyzylorda', 'Qostanay', 'Aqtobe', 'Aqtau', 'Atyrau', 'Oral'].includes(tzToks[1])) {
        return 5;
    }
    var tzDate = dayjs_1["default"].tz(date.toISOString(), 'YYYY-MM-DD HH:mm', tzString);
    var minutesOffset = Math.floor(tzDate.utcOffset() / DIV) * DIV;
    return minutesOffset / 60;
}
exports.getGMT = getGMT;
